import {LinkType} from '@workspaces/link';

export const appLinks: LinkType = {
  PROD: 'https://pilotage-rh.editions-tissot.fr/',
  PREPROD: 'https://pilotage-rh-preprod.editions-tissot.fr/',
  DEV: 'https://pilotage-rh-dev.editions-tissot.fr/',
  LOCAL: 'https://pilotage-rh-app.tissot-local.com/',
};
